export const WelcomeDialogTranslationKeys = {
  title: 'welcomeTitle',
  description: 'welcomeDescription',
  descriptionSecondary: 'welcomeDescriptionSecondary',
  btnTxt: 'welcomeEdit',
  backToSiteLinkTxt: 'welcomeBackToSite',
};
